import { Row, Col, Typography } from "antd";
import PageLoader from "Components/PageLoader/PageLoader";

const { Text, Title } = Typography;

/**
 * Summary tiles, same markup as Orders AnalyticsSummary.
 * `tiles`: [{ key, label, icon, colorClass, value }] (value already formatted).
 */
function CodeTiles({ tiles, loading, colProps = { xs: 24, sm: 8 } }) {
  if (loading)
    return <PageLoader showHero={false} showTabs={false} showCards={false} />;

  return (
    <Row gutter={[12, 12]}>
      {tiles.map(({ key, label, icon: Icon, colorClass, value }) => (
        <Col key={key} {...colProps}>
          <div className="rounded-2xl border border-border/50 bg-card p-5 shadow-card">
            <Row
              justify="space-between"
              align="middle"
              style={{ marginBottom: 8 }}
            >
              <Col>
                <Text type="secondary" className="text-xs">
                  {label}
                </Text>
              </Col>
              <Col>
                <div className={`rounded-lg p-1.5 ${colorClass}`}>
                  <Icon className="h-3.5 w-3.5" />
                </div>
              </Col>
            </Row>
            <Title level={4} style={{ margin: 0 }}>
              {value}
            </Title>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default CodeTiles;
